import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import AgentPrompt from "../integrate/_snippets/agent-prompt.mdx";
export const _frontmatter = {
  "props": {
    "framework": "string"
  }
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2 {...{
      "id": "beta-integration-via-llm"
    }}>{`Beta: integration via LLM`}</h2>
    <p>Install PostHog for {props.framework} in seconds with our wizard by running this prompt with <a href="/blog/envoy-wizard-llm-agent">LLM coding agents</a> like Cursor and Bolt, or by running it in your terminal. </p>

    <AgentPrompt mdxType="AgentPrompt" />
    <p>{`Or, to integrate manually, continue with the rest of this guide. `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      